(function () {
	angular
		.module('trackeye')
		.factory('Schedule', _ScheduleFactory);

	_ScheduleFactory.$inject = [];

	function _ScheduleFactory() {

		function Schedule() {
			this.enabled = true;
			this.activefrom = undefined;
			this.activeto = undefined;
			this.from = undefined;
			this.to = undefined;
			this.weekdays = 0;

			this.weekdaysBitmask = {mon: 0, tue: 1, wed: 2, thu: 3, fri: 4, sat: 5, sun: 6};
		}

		Schedule.prototype.isEnabled = function () {
			return this.enabled;
		};
		Schedule.prototype.getActiveFrom = function () {
			return this.activefrom;
		};
		Schedule.prototype.getActiveTo = function () {
			return this.activeto;
		};
		Schedule.prototype.getPeriodFrom = function () {
			return this.from;
		};
		Schedule.prototype.getPeriodTo = function () {
			return this.to;
		};
		Schedule.prototype.getWeekdays = function () {
			return this.weekdays;
		};
		/**
		 *
		 * @param {Boolean} bool
		 * @returns {Schedule}
		 */
		Schedule.prototype.setEnabled = function (bool) {
			this.enabled = bool;
			return this;
		};

		/**
		 * @param {Date}
		 * @returns {Schedule}
		 */
		Schedule.prototype.setActiveFrom = function (date) {
			this.activefrom = parseInt(date.getTime() / 1000);
			return this;
		};

		/**
		 * @param {Date}
		 * @returns {Schedule}
		 */
		Schedule.prototype.setActiveTo = function (date) {
			this.activeto = parseInt(date.getTime() / 1000);
			return this;
		};

		/**
		 * @param {Date}
		 * @returns {Schedule}
		 */
		Schedule.prototype.setFrom = function (hour, minute) {
			this.from = hour + "" + minute + "00";
			return this;
		};

		/**
		 * @param {Date}
		 * @returns {Schedule}
		 */
		Schedule.prototype.setTo = function (hour, minute) {
			this.to = hour + "" + minute + "00";
			return this;
		};

		Schedule.prototype.addWeekday = function (day) {
			if (!(day instanceof Array))
				day = [day];

			for (var i = 0; i < day.length; i++) {
				if (this.weekdaysBitmask[day[i]]) {
					this.weekdays | 1 << this.weekdaysBitmask[day[i]];
				}
			}
			return this;
		};

		Schedule.prototype.removeWeekday = function (day) {
			if (!(day instanceof Array))
				day = [day];

			for (var i = 0; i < day.length; i++) {
				if (this.weekdaysBitmask[day[i]]) {
					this.weekdays &= ~(1 << this.weekdaysBitmask[day[i]]);
				}
			}
			return this;
		};

		Schedule.prototype.setAllwaysActive = function () {
			this.weekdays = 127;
		}

		return Schedule;
	}
})();